import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2283a5b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArticleItem-img" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "ArticleItem-title line--2" }
const _hoisted_4 = { class: "ArticleItem-msg tstn" }
const _hoisted_5 = { class: "ArticleItem-msg-read" }
const _hoisted_6 = { class: "ArticleItem-msg-date" }

import { computed } from 'vue'
import { useRtfix, isD2C, useSite } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { formatViewNum } from '@/plugins/utils'
import { bury } from '@/util/useBury'
import { confirmLogin } from '@/util/useConfirm'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: null
  },
  // item存在的场景的筛选条件 0.根据文章类型；1.根据文章归档年月；2.根据文章热度；3.全部文章
  type: {
    type: Number,
    default: 2
  },
  // item跳转方式 1-router.push跳转 2-变更url参数
  itemJumpWay: {
    type: String,
    default: '2'
  }
},
  setup(__props) {

const props = __props
const store = useStore()
const token = store.getters.token
const user = computed(() => store.getters.user)

const route = useRoute()
const router = useRouter()



// 跳转文章详情
const toArticle = (id: string) => {
  console.log(token, props.item.noLoginRestriction)
  if (!token && props.item.noLoginRestriction === 3) {
    confirmLogin(async () => { })
    return
  }
  if (props.item.noMembershipRestriction === 3 && !user?.value?.membership?.templateLevel) {
    // router.push(useRtfix('VipLevel'))
    store.commit('status/memberDialog', true)
    return
  }
  if (props.itemJumpWay === '1') {
    location.href = process.env.VUE_APP_HELP_URL + useSite() + `/article/${id}`
    // router.push(useRtfix('article', { params: { id, type: props.type } }))
  } else if (props.itemJumpWay === '2') {
    const params: any = {
      ...route.params
    }
    params.id = id
    router.replace({ ...route, params })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ArticleItem", _unref(isD2C)() ? 'd2c' : 'b2b']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (toArticle(__props.item.frogArticleId)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        referrerPolicy: "no-referrer",
        src: __props.item.frogArticleImgUrl,
        alt: __props.item.frogArticleTitle
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.item.frogArticleTitle), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SvgIcon, {
          name: "查看",
          style: {"font-size":"12px","transform":"scale(1.4)"}
        }),
        _createTextVNode(" " + _toDisplayString(_unref(formatViewNum)(parseInt(__props.item.viewNum))), 1)
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.item.createTime), 1)
    ])
  ], 2))
}
}

})